<template>
  <div>
    <div>
      <div
        class="text-center preview-quiz edit-quiz p-3 mr-1 cursor-pointer text-sm text-primary border border-solid border-primary"
        @click="backToDetailPage"
      >
        <span class="ml-2 text-base text-primary">Item detail</span>
      </div>
    </div>
    <div v-if="next_question.length > 0 && !quiz_finished">
      <h2 class="pb-4">
        Question {{ next_question.length }} of {{ all_questions.length }}
      </h2>
      <h3>
        {{ next_question.length }}.
        {{ next_question[next_question.length - 1].question }}
      </h3>

      <div
        v-if="next_question[next_question.length - 1].type != 'multiple-select'"
      >
        <transition-group name="slide-fade">
          <div
            :key="index"
            v-for="(option, index) in next_question[next_question.length - 1]
              .options"
          >
            <vs-button
              @click="
                optionSelect(next_question[next_question.length - 1], option)
              "
              color="primary"
              :type="select_options.includes(option) ? 'filled' : 'border'"
              class="option"
              icon-pack="feather"
              :icon="
                select_options.includes(option)
                  ? 'icon-check-circle'
                  : 'icon-circle'
              "
            >
              {{ option }}
            </vs-button>
          </div>
        </transition-group>
      </div>

      <div
        v-if="next_question[next_question.length - 1].type == 'multiple-select'"
      >
        <vs-row>
          <transition-group name="slide-fade">
            <vs-col
              :key="index"
              v-for="(option, index) in next_question[next_question.length - 1]
                .options"
              vs-w="12"
              ><vs-button
                @click="
                  multipleOptionSelect(
                    next_question[next_question.length - 1],
                    option
                  )
                "
                color="primary"
                :type="multiple_select.includes(option) ? 'filled' : 'border'"
                icon-pack="feather"
                :icon="
                  multiple_select.includes(option)
                    ? 'icon-check-square'
                    : 'icon-square'
                "
                :class="multiple_select.includes(option) ? 'filled' : 'option'"
              >
                {{ option }}
              </vs-button>
            </vs-col>
          </transition-group>
        </vs-row>
      </div>
    </div>
    <div v-if="quiz_finished">
      <div :key="index" v-for="(option, index) in all_questions">
        <h3>
          {{ index + 1 }}.
          {{ option.question }}
        </h3>
        <h6 class="p-5">(Correct answer)</h6>
        <div v-if="option.type != 'multiple-select'">
          <div class="option">
            {{ option.correct_answer }}
          </div>
        </div>
        <div v-else>
          <div
            :key="i"
            v-for="(opt, i) in option.correct_answer"
            class="option"
          >
            {{ opt }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataProvider from "../../../services/data-provider";

export default {
  data() {
    return {
      all_questions: [],
      item_data: "",
      next_question: [],
      multiple_select: [],
      select_options: [],
      quiz_finished: false,
    };
  },
  methods: {
    optionSelect(question, option) {
      if (
        question.correct_answer.includes(option) ||
        question.correct_answer == option
      ) {
        this.select_options.push(option);
        this.next_question[
          this.next_question.length - 1
        ].select_option = option;
        if (this.all_questions[this.next_question.length]) {
          this.next_question.push(
            this.all_questions[this.next_question.length]
          );
        } else {
          this.quiz_finished = true;
        }
      } else {
        this.$vs.notify({
          color: "warning",
          title: "Wrong select!",
        });
      }
      this.select_options = [];
      this.multiple_select = [];
      console.log(this.next_question);
    },

    multipleOptionSelect(question, option) {
      if (
        question.correct_answer.includes(option) ||
        question.correct_answer == option
      ) {
        let i = this.multiple_select.indexOf(option);
        if (i != -1) {
          this.multiple_select.splice(i, 1);
        } else {
          this.multiple_select.push(option);
        }
      } else {
        this.$vs.notify({
          color: "warning",
          title: "Wrong select!",
        });
      }
      console.log(question.correct_answer.length == this.multiple_select.length)
      if (question.correct_answer.length == this.multiple_select.length) {

        if (this.all_questions[this.next_question.length]) {
          this.next_question.push(
            this.all_questions[this.next_question.length]
          );
          this.multiple_select=[]
        } else {
          this.quiz_finished = true;
        }
      }
    },
    saveMultipleSelection() {},
    backToDetailPage() {
      this.$router.back();
    },
    fetch_item_details(category_name, id) {
      console.log(this.item_data);
      category_name = category_name.split(" ").join("_");
      DataProvider.getDetailDataFromCloud(
        "/health_hacks_item_detail/",
        id,
        category_name
      ).then((data) => {
        console.log("item-details:", data);
        if (data.data) {
          this.item_data = data.data;

          this.all_questions = this.item_data.questions;
          this.all_questions.filter((res) => {
            if (res.type == "multiple-select") {
              return (res.options = res.correct_answer.concat(
                res.incorrect_answers
              ));
            } else if (res.type == "boolean") {
              return (res.options = [
                res.incorrect_answers[0],
                res.correct_answer,
              ]);
            } else if (res.type == "single-select") {
              return (res.options = [
                res.incorrect_answers[0],
                res.incorrect_answers[2],
                res.correct_answer,
                res.incorrect_answers[1],
              ]);
            }
          });
          console.log("all_questions:", this.all_questions);

          this.next_question.push(this.all_questions[0]);
        }
      },err=>{
        DataProvider.sendSentryErrorLog(err)
      });
    },
  },
  created() {
    console.log(this.$route.params.category, this.$route.params.item_id);
    this.fetch_item_details(
      this.$route.params.category,
      this.$route.params.item_id
    );
  },
};
</script>

<style lang="scss">
.option {
  i {
    font-size: 18px;
  }
  margin: 10px;
  padding: 16px !important;
  background-color: white !important;
  border-color: white;
  box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
  -webkit-transition: all 0.3s ease-in-out;
  width: 301px;
  justify-content: left !important;
}
.edit-quiz {
    width: 125px;
    margin: auto;
    border-radius: 50px;
}
.filled {
  i {
    font-size: 18px;
  }
  margin: 10px;
  padding: 16px !important;
  // background-color: white !important;
  border-color: white;
  box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
  -webkit-transition: all 0.3s ease-in-out;
  width: 301px;
  justify-content: left !important;
}
</style>